import { date } from 'quasar';

/**
 * Datetime format to use based on locale.
 */
const LOCALE_DATETIME_FORMAT = {
    'en-US': 'YYYY/MM/DD HH:mm:ss',
    'fr-FR': 'YYYY/MM/DD HH:mm:ss',
    es: 'YYYY/MM/DD HH:mm:ss',
    'pt-BR': 'YYYY/MM/DD HH:mm:ss'
};

/**
 * Get datetime format based on locale.
 * @param {String} datetime
 * @param {String} locale
 * @return {String}
 */
function getLocaleFormat(datetime, locale) {
    if (datetime === null || datetime === '') {
        return '-';
    } else {
        return date.formatDate(datetime, LOCALE_DATETIME_FORMAT[locale]);
    }
}

/**
 * Get time from datetime.
 * @param {String} datetime
 * @returns {String}
 */
function getTime(datetime) {
    if (datetime === null || datetime === '') {
        return '-';
    } else {
        return date.formatDate(datetime, 'HH:mm:ss');
    }
}

/**
 * Get month, day and time from datetime.
 * @param {String} datetime
 * @param {String} locale
 * @param {String} timezone
 * @returns {String}
 */
function getMonthDayTime(datetime, locale, timezone) {
    if (timezone === 'UTC') {
        if (!datetime) {
            return '-';
        }
        return new Date(datetime).toUTCString();
    } else {
        const convertedDate = getLocaleFormat(datetime, locale);
        return date.formatDate(convertedDate, 'MMM DD, HH:mm:ss');
    }
}

export { getLocaleFormat, getTime, getMonthDayTime, LOCALE_DATETIME_FORMAT };
